import type { JSX, ParentComponent } from "solid-js";
import { splitProps } from "solid-js";
import { cn } from "@/libs/cn";

export const OnboardingTitle: ParentComponent<
  JSX.HTMLAttributes<HTMLHeadingElement>
> = (props) => {
  const [local, rest] = splitProps(props, ["children", "class", "classList"]);
  return (
    <h1
      class={cn("text-3xl font-display font-medium max-w-2xl", local.class)}
      classList={local.classList}
      {...rest}
    >
      {local.children}
    </h1>
  );
};

export const OnboardingDescription: ParentComponent<
  JSX.HTMLAttributes<HTMLParagraphElement>
> = (props) => {
  const [local, rest] = splitProps(props, ["children", "class", "classList"]);
  return (
    <p
      class={cn("text-gray-500 max-w-xl", local.class)}
      classList={local.classList}
      {...rest}
    >
      {local.children}
    </p>
  );
};
